import { gql } from '@apollo/client';
import useGQLQuery from 'src/lib/graphql/hooks/useGQLQuery';
import { EP_ANCESTORS_DETAILS_FIELDS } from '../common/fragments/ancestorsDetails';
const QP_DETAILS_QUERY = gql `
  query EP_QPDetails($qpID: String!) {
    ep_qp(qpID: $qpID) {
      id
      type
      data {
        label
        dateNL
        qpImages {
          uri
        }
      }
      ctime
      author {
        id
        details {
          avatarURL
          firstName
          lastName
          userName
        }
      }
      ancestorsDetails {
        ...EPAncestorsDetailsFields
      }
      config {
        WRITTEN_QUESTION {
          hasExaminersFeedback
        }
      }
    }
  }

  ${EP_ANCESTORS_DETAILS_FIELDS}
`;
export function useQPDetailsQuery(qpID, options) {
    return useGQLQuery(QP_DETAILS_QUERY, {
        variables: {
            qpID,
        },
        ...options,
    });
}
